import {Validators} from "@angular/forms";
import {ECrudFilterType} from "./crud.filter-type.enum";


export interface ITableConfig {
  cells: ICellConfig[];
  actions: string[];
  rowClass?: (item: any) => {} | null,
}
export interface ITableGroupAction {
  action: string;
  icon: string;
  name: string;
}

type TSC = () => string;
type TSCVAL = (val: any) => string;

export enum EFilterType {
  NONE = 0,
  TEXT = 1,
  SELECT = 2,
  DATE = 3,
}

export enum EInputType {
  DISABLED = 0,
  TEXT = 1,
  NUMBER = 14,
  SELECT = 2,
  DATE = 3,
  PASSWORD = 4,
  TEXTAREA = 5,
  DATETIME = 6,
  EMAIL = 7,
  ROLE_ACCESS = 8,
  FILE = 9,
  BOOLEAN = 10,
  RICH = 11,
  FILE_WITH_MARKS = 12,
  FILE_PREVIEW =13,
}

export interface ICellConfig {
  header: string | TSC;
  sortable: boolean;
  filterType: EFilterType;
  crudFilterType?: ECrudFilterType;
  value?: TSCVAL;
  field: string;
  options?: () => {value: string; label: string}[];
}


export interface IEditConfig {
  groups: {
      name: string | TSC;
      configs: IInputConfig[];
  }[]
}


export interface IInputConfig {
  type: EInputType;
  validators: Validators[];
  field: string;
  name: string;
  cdnWithSuffix?: boolean;
  value?: TSCVAL;
  readonly?: boolean;
  options?: () => {value: string; label: string}[];
}
